// Thin async entry (DEV-1057). On a Cloudflare Pages preview host this resolves
// the per-PR API stand (health-probed, ~2s budget) BEFORE the render module is
// imported, so `config/env.ts`'s `API_URL`/`ID_URL` consts — and the api-client
// `baseURL` baked from them in `./api/setup` — freeze at the resolved value.
// Off-preview it is an instant no-op. The real bootstrap lives in `./bootstrap`,
// dynamically imported here so it (and `config/env.ts`) evaluate only after the
// runtime endpoints are stored.
//
// IMPORTANT: keep this module's static imports limited to `./lib/resolve-endpoints`
// (a leaf that does NOT import `config/env.ts` or `./api/setup`). Importing either
// here — directly or transitively — would freeze the endpoint consts / bake the
// api-client baseURL before resolution runs.
import { resolveAndStoreEndpoints } from './lib/resolve-endpoints';

// Async IIFE (not top-level await) so the bundle needs no TLA-capable build
// target: resolve the runtime endpoints, then dynamically import the render body.
void (async () => {
  await resolveAndStoreEndpoints();
  await import('./bootstrap');
})();
